<label class="text-field" [attr.for]="inputId() || null">
  <span class="text-field__label">
    {{ label() }}
    @if (required()) {
      <span class="text-field__required">*</span>
    }
  </span>

  <div class="text-field__control">
    @if (prefixIcon()) {
      <mat-icon class="text-field__prefix">{{ prefixIcon() }}</mat-icon>
    }
    <input
      class="text-field__input"
      [id]="inputId() || null"
      [type]="effectiveType()"
      [placeholder]="placeholder()"
      [value]="value()"
      [autocomplete]="autocomplete()"
      [readOnly]="readonly()"
      [disabled]="isDisabled()"
      [attr.inputmode]="inputMode()"
      (input)="onInput($event)"
      (blur)="onBlur()"
    />
    @if (isPassword()) {
      <button
        type="button"
        class="text-field__toggle"
        tabindex="-1"
        [attr.aria-label]="passwordVisible() ? 'Hide password' : 'Show password'"
        (click)="togglePasswordVisibility(); $event.preventDefault()"
      >
        <mat-icon>{{ passwordVisible() ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    }
  </div>

  @if (invalid() && errorText()) {
    <span class="text-field__error">{{ errorText() }}</span>
  }
</label>
